import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PasswordChangeForm } from '@/repositories/generated';
import { ErrorBody } from '@/types';

export const loginUserPassword = http.post(
  createMockEndpoint('/login_user/password'),
  async ({ request }) => {
    const requestBody = await request.json() as PasswordChangeForm;
    await delay(500);

    const createResponse = (): ErrorBody | object => {
      if (requestBody.password.includes('error')) {
        return {
          error: {
            code: 'MOCK_API_ERROR',
            message: 'モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。',
          },
        };
      }
      return {};
    };

    const response = createResponse();
    const statusCode = 'error' in response ? 400 : 200;

    return HttpResponse.json(response, { status: statusCode });
  },
);
